/* eslint-disable no-sequences */
import axios from "axios";
import { apiToken, apiUrl_forProductFilters } from "./constants";

const CancelToken = axios.CancelToken;

// get product types
export let cancelGetProductTypesApi;
export async function getProductTypes(token, query = "") {
    if (token) {
        const productTypes = await axios.get(
            apiUrl_forProductFilters + "global/attributes",
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetProductTypesApi = c;
                }),
            }
        );
        return productTypes;
    } else {
        console.log("Please add required parameters");
    }
}

// add product type
export let cancelAddProductTypesApi;
export async function addProductType(token, productTypeData) {
    if ((token, productTypeData)) {
        const productTypes = await axios.post(
            apiUrl_forProductFilters + "global/attribute",
            productTypeData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelAddProductTypesApi = c;
                }),
            }
        );
        return productTypes;
    } else {
        console.log("Please add required parameters");
    }
}

// get product type detail
export let cancelGetProductTypeDetailsApi;
export async function getProductTypeDetails(token, id) {
    if (token && id) {
        const productTypes = await axios.get(
            apiUrl_forProductFilters + "global/attributes/" + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelGetProductTypeDetailsApi = c;
                }),
            }
        );
        return productTypes;
    } else {
        console.log("Please add required parameters");
    }
}

// update product type
export let cancelEditProductTypesApi;
export async function editProductType(token, productTypesData) {
    if ((token, productTypesData)) {
        const ProductTypes = await axios.put(
            apiUrl_forProductFilters +
                "global/attribute/" +
                productTypesData.attribute_id,
            productTypesData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelEditProductTypesApi = c;
                }),
            }
        );
        return ProductTypes;
    } else {
        console.log("Please add required parameters");
    }
}

// delete product type
export let cancelDeleteProductTypeApi;
export async function deleteProductTypes(token, id) {
    if (token && id) {
        const productTypes = await axios.delete(
            apiUrl_forProductFilters + "global/attribute/" + id,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Api-Token": apiToken,
                    "Access-Token": "",
                },
            },
            {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancelDeleteProductTypeApi = c;
                }),
            }
        );
        return productTypes;
    } else {
        console.log("Please add required parameters");
    }
}
